var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { PropertyService } from './../api/property.service';
import { AgencyService } from './../api/agency.service';
import { OnInit, Injector } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseComponent } from './base-component';
import { OpenModalService } from './shared/modals/open-modal.service';
var HomeBaseComponent = /** @class */ (function (_super) {
    __extends(HomeBaseComponent, _super);
    function HomeBaseComponent(injector, agencyService, route, propertyService, openModalService) {
        var _this = _super.call(this, injector) || this;
        _this.agencyService = agencyService;
        _this.route = route;
        _this.propertyService = propertyService;
        _this.openModalService = openModalService;
        _this.properties = [];
        _this.reasons = [];
        return _this;
    }
    HomeBaseComponent.prototype.ngOnInit = function () {
        var _this = this;
        var promise = this.propertyService.getPromoProperties();
        if (promise) {
            promise.then(function (properties) {
                _this.properties = properties;
            });
        }
        this.route.data.forEach(function (data) {
            if (data.reasons)
                _this.reasons = data.reasons;
        });
        this.setTitle(this.agencyService.agency.name);
    };
    HomeBaseComponent.prototype.openReasonModal = function (reason) {
        this.openModalService.showDetailsModal(reason.name, undefined, reason.description, reason.image);
    };
    return HomeBaseComponent;
}(BaseComponent));
export { HomeBaseComponent };



// WEBPACK FOOTER //
// ./src/app/common-theme/base-components/home-base.component.ts.pre-build-optimizer.js